import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { user, loading } = useAuth();
    const { t } = useTranslation();

    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "60vh",
                    color: "var(--color-text-muted)",
                }}
            >
                {t("common.loading")}
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/client-portal" replace />;
    }

    if (requireAdmin && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }

    if (!requireAdmin && user.role !== "admin") {
        if (user.account_status === "pending") {
            return <Navigate to="/pending" replace />;
        }
        if (
            user.account_status === "declined" ||
            user.account_status === "archived"
        ) {
            return <Navigate to="/client-portal" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
